/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme, Heading } from "@nordcloud/gnui";

export const MultiSelectSubmitContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${theme.spacing.spacing03};
  background-color: ${theme.color.background.ui01};
  border-top: 1px solid ${theme.color.border.border01};
  position: sticky;
  bottom: 0;
  margin-right: auto;
  margin-left: auto;
`;

export const SwitchWrap = styled.div`
  pointer-events: none;
`;

export const ItemHeading = styled(Heading)`
  word-break: break-all;
  text-align: left;
  margin-right: ${theme.spacing.spacing01};
`;
